import React, { useContext, useState, useEffect } from "react";
import { Modal, Box, TextField, Button, Typography, FormControl, Table, TableBody, TableCell, TableContainer, TableRow, Paper, IconButton, Grid, TableHead, Checkbox } from "@mui/material";
import { ThemeContext } from "../../../context/ThemeContext";
import { updateSLTPOrders, deleteSLTPOrders, modifyPositionSLTP } from "../../../api/request/dashboard/dashboard";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from "react-redux";
import { editSLTPOrder, deleteSLTPOrder, addSLTPOrder } from "../../../store/Slices/orderPositionSlice";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { DeleteOutline, EditOutlined } from '@mui/icons-material'
import { useSymbolPrices } from "../../../context/WebSocketContext";

const AddEditModal = ({ isOpenEdit, setIsOpenEdit, isEdit, formData, handleChange, handleEdit, handlePlaceOrder, sltp }) => {
    const symbols = useSymbolPrices();
    const { darkMode } = useContext(ThemeContext);
    const { allSymbolParams } = useSelector((state) => state.symbol);
    const [slValidation, setSlValidation] = useState(0)
    const [tpValidation, setTpValidation] = useState(0)
    const [isDisabled, setIsDisabled] = useState(false)
    useEffect(() => {
        const symbol = symbols?.[sltp?.symbolId]
        const symbolParameterData = allSymbolParams?.[sltp?.symbolId]
        console.log(symbol?.digits)
        const stopOffset = (symbolParameterData?.stopOffset ?? 10) * (1 / Math.pow(10, symbol.digits));
        const limitOffset = (symbolParameterData.limitOffset ?? 10) * (1 / Math.pow(10, symbol.digits));

        // Stop Loss Calculations
        const stopLoss = sltp?.side === 1
            ? (symbol?.bid - limitOffset).toFixed(symbol.digits) // Buy Condition
            : (symbol?.ask + stopOffset).toFixed(symbol.digits); // Sell Condition
        setSlValidation(stopLoss)

        // Take Profit Calculations
        const takeProfit = sltp?.side === 1
            ? (symbol?.ask + stopOffset).toFixed(symbol.digits)  // Buy Condition
            : (symbol?.bid - limitOffset).toFixed(symbol.digits); // Sell Condition
        setTpValidation(takeProfit)

        if (sltp.side === 1) {
            const slValid = formData.st > slValidation
            const tpValid = formData.tp < tpValidation
            setIsDisabled(slValid || tpValid)
        } else {
            const slValid = formData.st < slValidation
            const tpValid = formData.tp > tpValidation
            setIsDisabled(slValid || tpValid)
        }
    }, [symbols[sltp?.symbolId], allSymbolParams, sltp])

    return (
        <Modal open={isOpenEdit} maxWidth="md" width="md" onClose={e => setIsOpenEdit(false)}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', }}>
                <Box className="bg-primary" sx={{ padding: '5px', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography id="edit-position-modal" variant="body1" sx={{ color: "var(--white)" }} >{!isEdit ? "Add" : "Edit"} ProfitLoss</Typography>
                    <IconButton onClick={e => setIsOpenEdit(false)} sx={{ color: "var(--white)" }}>
                        <CloseIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                </Box>
                <Box sx={{ padding: 2 }} container>
                    <div className="grid grid-cols-2">
                        <div className="mx-2 mb-1">
                            {/* <div className="mb-0.5 font-medium text-sm">Stop Loss {sltp.side === 1 ? '>' : '<'} {slValidation} </div> */}
                            <div className="mb-0.5 font-medium text-sm">Stop Loss</div>
                            <TextField focused name="st" variant="outlined" value={formData.st} onChange={handleChange} />
                        </div>
                        <div className="mx-2 mb-1">
                            {/* <div className="mb-0.5 font-medium text-sm">Take Profit {sltp.side === 1 ? '<' : '>'} {tpValidation} </div> */}
                            <div className="mb-0.5 font-medium text-sm">Take Profit</div>
                            <TextField focused name="tp" variant="outlined" value={formData.tp} onChange={handleChange} />
                        </div>
                        <div className="mx-2 ">
                            <div className="mb-0.5 font-medium text-sm">Amount</div>
                            <TextField focused name="amount" variant="outlined" value={formData.amount} onChange={handleChange} />
                        </div>
                        <div className="mx-2  mt-auto">
                            <Button onClick={isEdit ? handleEdit : handlePlaceOrder} variant="contained" size="small" sx={{ height: '36px', width: '100%' }}>
                                {isEdit ? "Edit SLTP" : "Add SLTP"}
                            </Button>
                        </div>
                    </div>
                </Box>
            </Box>
        </Modal>
    )
}

export default AddEditModal